module.exports = __webpack_public_path__ + "static/img/logo-transverse.52906c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo-transverse.png
// module id = BTV8
// module chunks = 21